import React, { useEffect, useState } from "react";
import { ScreenHeader } from "react-library";
import PlotSerivce, { TSupportedCrop } from "../../services/plot.service";
import { useParams, useNavigate } from "react-router-dom";
import { Routes } from "../../routes";
import dayjs from "dayjs";
import CropSerivce, {
  TCrop,
  TCropVarietyOption,
  TNewCropSeasonPayload,
} from "../../services/crop.service";
import { t } from "../../services/locale.service";

const AddCrop: React.FC = () => {
  const { plotId } = useParams();
  const navigate = useNavigate();
  const headerTitle = t("Add_Crop");

  const [enableSelectCrop, setEnableSelectCrop] = useState<boolean>(false);
  const [mostRecentCropSownId, setMostRecentCropSownId] = useState<
    string | null
  >(null);
  const [cropList, setCropList] = useState<Array<TSupportedCrop>>();
  const [cropImages, setCropImages] = useState<Array<TCrop>>();
  const [selectedCrop, setSelectedCrop] = useState<TSupportedCrop>();
  const [cropVarietyList, setCropVarietyList] =
    useState<Array<TCropVarietyOption>>();
  const [selectedCropVariety, setSelectedCropVariety] =
    useState<TCropVarietyOption>();
  const [showCropVarietyModal, setShowCropVarietyModal] =
    useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const filteredVarieties = cropVarietyList?.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLatestCropSownId();
  }, []);

  const getLatestCropSownId = async () => {
    try {
      const res = await PlotSerivce.getRecentCropSownId(plotId ?? "");

      if (res.length > 0) {
        setMostRecentCropSownId(res[0].cropSownId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const continueCropSeason = async () => {
    try {
      if (!mostRecentCropSownId) return;
      await PlotSerivce.continueCropSeason(mostRecentCropSownId);
      navigate(Routes.home);
    } catch (error) {
      console.log(error);
    }
  };

  const openStartSeason = async () => {
    try {
      const cropList = await PlotSerivce.getSupportedCrop();
      const cropImage = await CropSerivce.getCropImage();
      setCropList(cropList);
      setCropImages(cropImage);
      setEnableSelectCrop(true);
    } catch (error) {
      console.log(error);
    }
  };

  const cropImageById = (cropId: string) => {
    const item = cropImages?.find((item) => item.id === cropId);
    return item ? item.image : undefined;
  };

  const getCropVarietyList = async () => {
    try {
      if (selectedCrop?.id) {
        setSelectedCropVariety(undefined);
        const cropVarietyList = await CropSerivce.getCropVariety(
          selectedCrop?.id
        );
        if (cropVarietyList.length) {
          const varietyList = [];
          for (let i = 0; i < cropVarietyList.length; i++) {
            let cropVarietyO = {
              ...cropVarietyList[i],
              varietyId: cropVarietyList[i].id,
              id: i,
            };
            if (cropVarietyList[i]?.displayName) {
              cropVarietyO = {
                ...cropVarietyO,
                name: cropVarietyList[i]?.displayName,
              };
            }
            varietyList.push(cropVarietyO);
          }
          setCropVarietyList(varietyList);
          setShowCropVarietyModal(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setCropVarietyList([]);
    getCropVarietyList();
  }, [selectedCrop]);

  const save = async () => {
    if (
      !selectedCrop ||
      !plotId ||
      !selectedDate ||
      (cropVarietyList?.length && !selectedCropVariety)
    ) {
      return;
    }
    const payload: TNewCropSeasonPayload = {
      plotId: plotId,
      sowingDate: selectedDate.toDate(),
      cropId: selectedCrop.cropId,
      crop: selectedCrop.cropName,
    };
    if (selectedCropVariety?.varietyId) {
      payload.varietyId = selectedCropVariety.varietyId;
    }
    try {
      await CropSerivce.startNewSeason(payload);
      navigate(Routes.home);
    } catch (error) {
      console.log(error);
    }
  };

  if (enableSelectCrop)
    return (
      <div>
        <ScreenHeader screenName={t("start_crop_season")} />
        <div
          style={{
            alignItems: "center",
            paddingBottom: 30,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <p
            style={{
              color: "#585757",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 10,
            }}
          >
            {t("Sowing_Date")}
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                backgroundColor: "#54a9f1",
                height: 5,
                width: "25%",
              }}
            ></div>

            <div
              style={{
                width: 130,
                height: 40,
                borderRadius: 4,
                backgroundColor: "#ffffff",
                borderStyle: "solid",
                borderWidth: 2,
                borderColor: "#ababab",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="date"
                value={selectedDate.format("YYYY-MM-DD")}
                onChange={(e) => {
                  setSelectedDate(dayjs(e.target.value));
                }}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: 15,
                  color: "#434343",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "100%",
                  height: "100%",
                  padding: 0,
                }}
              />
            </div>

            <div
              style={{
                backgroundColor: "#54a9f1",
                height: 5,
                width: "25%",
              }}
            ></div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            marginBottom: "25%",
          }}
        >
          {cropList?.map((item: TSupportedCrop) => (
            <div
              onClick={() => setSelectedCrop(item)}
              key={item.id}
              style={{
                borderRadius: 15,
                height: 100,
                width: 100,
                backgroundColor: "#ffffff",
                borderStyle: "solid",
                borderWidth: 2.5,
                borderColor:
                  item.cropId === selectedCrop?.cropId ? "#2cbc63" : "#ababab",
                margin: 5,
                alignItems: "center",
                alignSelf: "center",
                justifyItems: "center",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                overflow: "hidden",
                padding: "5px",
              }}
            >
              {!!cropImageById(item.id) && (
                <img
                  style={{
                    width: 40,
                    height: 40,
                    paddingTop: 5,
                  }}
                  src={cropImageById(item.id)}
                  alt="Crop"
                />
              )}
              <p
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  margin: "5px 0",
                }}
              >
                {item.displayName}
                {item.cropId === selectedCrop?.cropId &&
                  selectedCropVariety?.name && (
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 11,
                      display: "block",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {selectedCropVariety?.name}
                  </span>
                )}
              </p>
            </div>
          ))}
        </div>
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor:
              !selectedCrop ||
              !selectedDate ||
              (cropVarietyList?.length && !selectedCropVariety)
                ? "#e2e2e2"
                : "#0c9611",
            borderRadius: 18,
            width: "90%",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 0",
            zIndex: 1000,
            boxShadow: "0px -4px 15px rgba(0, 0, 0, 0.2)",
          }}
          onClick={save}
        >
          <p
            style={{
              fontSize: 18,
              color:
                !selectedCrop ||
                !selectedDate ||
                (cropVarietyList?.length && !selectedCropVariety)
                  ? "#434343"
                  : "#ffffff",
              fontWeight: "bold",
              textAlign: "center",
              margin: 0,
            }}
          >
            {t("start")}
          </p>
        </div>

        {showCropVarietyModal && cropVarietyList?.length && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "90%",
                maxWidth: 500,
                height: 400,
                backgroundColor: "white",
                borderRadius: 22,
                padding: "15px",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p style={{ paddingTop: 15, fontSize: 18, color: "#000000" }}>
                  Select {selectedCrop?.cropName} Crop Variety:
                </p>
                <button
                  onClick={() => setShowCropVarietyModal(false)}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#888",
                    cursor: "pointer",
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                >
                  &times;
                </button>
              </div>

              <input
                type="text"
                placeholder="Search Crop Variety..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  padding: "8px",
                  borderRadius: "4px",
                  marginBottom: "15px",
                  border: "1px solid #ccc",
                }}
              />

              <div>
                {filteredVarieties?.length ? (
                  filteredVarieties.map((item) => (
                    <p
                      key={item.id}
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #eee",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedCropVariety(item);
                        setShowCropVarietyModal(false);
                      }}
                    >
                      {item.name}
                    </p>
                  ))
                ) : (
                  <p>{t("no_crop_varieties")}</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );

  return (
    <div className="cfr-container">
      <ScreenHeader screenName={headerTitle} />
      <div
        style={{
          borderColor: "#e5e5e5",
          borderWidth: 1,
          width: "90%",
          alignSelf: "center",
          backgroundColor: "#ffffff",
          margin: 10,
          padding: 1,
          borderRadius: 3,
          justifyContent: "center",
        }}
      >
        <div
          style={{
            borderColor: "#ffbc33",
            borderWidth: 1,
            alignSelf: "center",
            backgroundColor: "#ffffff",
            margin: 3,
            boxShadow: "9px solid",
            padding: 10,
            borderRadius: 3,
          }}
        >
          {/* <img
            src={alertIcon}
            style={{
              width: 70,
              height: 70,
              alignSelf: "center",
              marginTop: -50,
            }}
            //resizeMode="contain"
          /> */}
          <p
            style={{
              fontSize: 26,
              fontWeight: "bold",
              fontStyle: "normal",
              letterSpacing: 0,
              textAlign: "center",
              color: "#434343",
            }}
          >
            {t("no_season_found")}
          </p>
          <p
            style={{
              fontSize: 15,
              fontWeight: "600",
              fontStyle: "normal",
              letterSpacing: 0,
              textAlign: "center",
              color: "#aca9a9",
            }}
          >
            {t("start_new_season")}
            
          </p>
          <div
            style={{
              backgroundColor: "#ffe981",
              padding: 2,
              borderRadius: 4,
              minWidth: 260,
              alignSelf: "center",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
              marginTop: 40,
            }}
            onClick={openStartSeason}
          >
            <p
              style={{
                fontSize: 16,
                fontWeight: "bold",
                fontStyle: "normal",
                letterSpacing: 0.8,
                textAlign: "center",
                color: "#434343",
              }}
            >
              {t("start_crop_season")}
            </p>
          </div>

          {!!mostRecentCropSownId && (
            <div
              style={{
                backgroundColor: "#ffe981",
                padding: 2,
                borderRadius: 4,
                minWidth: 260,
                marginBottom: 20,
                alignSelf: "center",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 40,
              }}
              onClick={continueCropSeason}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  fontStyle: "normal",
                  letterSpacing: 0.8,
                  textAlign: "center",
                  color: "#434343",
                }}
              > {t("Restart_Crop_Season")}
              
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCrop;
